import { lang, commonLang } from '@umu/ukit-lang';
/**
 * @description
 */

import './departmentSelectDialog.scss';
import { $window } from '@umu/umu-dom';
import React, { useReducer, useMemo, useRef } from 'react';
import { Button, ButtonType } from '@umu/umu-design';
import DListView, { IDListRef } from './components/@list/list';
import { EPlatformTravelType as TravelType, EPlatformSectionType as SectionType } from '@umu/umu-types';
import { DialogReducer } from './dialogReducer';
import { DialogContext, initState } from './dialogContext';
import { DEPARTMENT_ACCESS, EnterpriseRoleType } from '@umu/umu-types';

interface IProps {
    title: string; // 对话框title
    btnConfirmType?: ButtonType; // 确认按钮类型-与Button 类型
    departmentId: string; // 默认展示的部门id
    travelType: TravelType; // 对话框类型，
    isRadio?: boolean; // 是否单选模式
    expendParams?: {
        [propName: string]: string;
    };// 接口额外扩展参数
    excludeDepartmentIds?: string; // 排除的id 用,隔开
    defaultSelectedList?: string; // id 用,隔开
    source?: 'department_board'; // 使用场景
    isAllowSelect?: boolean; // 是否允许支持全选
    checkableRoot?: boolean; // 是否开放选择根部门
    allSelectText?: string; // 全选展示文案
    isShowMember?: boolean; // 是否展示成员
    hasAllPermissionRoles?: EnterpriseRoleType[]; // 拥有所有部门权限的角色，默认 [学习负责人, 管理员]
    limit?: number; // 多选个数限制
    access?: DEPARTMENT_ACCESS;
    cbClose?: () => void;
    cbDo?: (data: any[]) => void; // 已选回调。
}

export default function DepartmentSelectDialog(props: IProps) {
    const hasAllPermissionRoles = useMemo(() => (props.hasAllPermissionRoles || [EnterpriseRoleType.MANAGE, EnterpriseRoleType.ADMIN]), [props.hasAllPermissionRoles]);
    const [state, dispatch] = useReducer(DialogReducer, { ...initState, hasAllPermissionRoles });
    const refList = useRef<IDListRef>(null);
    const onConfirm = () => {
        if (!props.cbDo) {
            return;
        }
        const values = Object.values(state.selectedMap);
        const selectList: any[] = [];
        values.forEach((value) => {
            if (value.oriData) {
                selectList.push(value.oriData);
            }
        });
        const funCb = props.cbDo;
        $window.setTimeout(() => {
            funCb(selectList);
        }, 100);
    };
    const onClose = () => {
        if (refList && refList.current) {
            refList.current.cleanStateByParent();
        }
        if (props.cbClose) {
            const funCb = props.cbClose;
            $window.setTimeout(() => {
                funCb();
            }, 100);
        }
    };

    const render = () => {
        const title = props.title;
        const btnConfirmType = props.btnConfirmType || 'primary';
        const subTitleLeft = lang('待选');
        const subTitleRight = lang('已选');
        return (
            <DialogContext.Provider
                value={{
                    state,
                    dispatch,
                }}
            >
                <div className="department-select-dialog" title="">
                    <div className="content-head">
                        <p>{title}</p>
                    </div>
                    <div className="content-body">
                        <div className="left">
                            <span className="subtitle">{subTitleLeft}</span>
                            <div className="subcontent">
                                <DListView
                                    access={props.access}
                                    type={props.travelType}
                                    section={SectionType.left}
                                    departmentId={props.departmentId}
                                    isRadio={props.isRadio}
                                    expendParams={props.expendParams}
                                    ref={refList}
                                    defaultSelectedList={props.defaultSelectedList}
                                    excludeDepartmentIds={props.excludeDepartmentIds}
                                    isAllowSelect={props.isAllowSelect}
                                    isShowMember={props.isShowMember}
                                    allSelectText={props.allSelectText}
                                    checkableRoot={props.checkableRoot}
                                    limit={props.limit}
                                    clsName="left"
                                    hasAllPermissionRoles={hasAllPermissionRoles}
                                />
                            </div>
                        </div>
                        <div className="right">
                            <span className="subtitle">{subTitleRight}</span>
                            <div className="subcontent">
                                <DListView
                                    access={props.access}
                                    type={props.travelType}
                                    section={SectionType.right}
                                    departmentId={props.departmentId}
                                    isRadio={props.isRadio}
                                    checkableRoot={props.checkableRoot}
                                    clsName="right"
                                    hasAllPermissionRoles={hasAllPermissionRoles}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="dialog-content-footer">
                        <Button className="dialog-footer-btn" type={btnConfirmType} onClick={onConfirm}>
                            {commonLang('确定')}
                        </Button>
                        <Button className="dialog-footer-btn" type="ghost-grey" onClick={onClose}>
                            {commonLang('取消')}
                        </Button>
                    </div>
                </div>
            </DialogContext.Provider>
        );
    };
    return render();
}
